"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const UnsubscribeSubscriptionError_1 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_2 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_3 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_4 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_5 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_6 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_7 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UnsubscribeSubscriptionError_8 = require("./types/UnsubscribeSubscription/UnsubscribeSubscriptionError");
const UpdateInformationsError_1 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_2 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_3 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_4 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_5 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_6 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_7 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_8 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_9 = require("./types/UpdateInformations/UpdateInformationsError");
const UpdateInformationsError_10 = require("./types/UpdateInformations/UpdateInformationsError");
const CreateStripeSetupIntentError_1 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_2 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_3 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_4 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_5 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_6 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_7 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateStripeSetupIntentError_8 = require("./types/CreateStripeSetupIntent/CreateStripeSetupIntentError");
const CreateSubscriptionError_1 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_2 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_3 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_4 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_5 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_6 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_7 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_8 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_9 = require("./types/CreateSubscription/CreateSubscriptionError");
const CreateSubscriptionError_10 = require("./types/CreateSubscription/CreateSubscriptionError");
const ExecutePaypalPaymentError_1 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_2 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_3 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_4 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_5 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_6 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_7 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecutePaypalPaymentError_8 = require("./types/ExecutePaypalPayment/ExecutePaypalPaymentError");
const ExecuteStripePaymentError_1 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_2 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_3 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_4 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_5 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_6 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_7 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_8 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_9 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const ExecuteStripePaymentError_10 = require("./types/ExecuteStripePayment/ExecuteStripePaymentError");
const GetGroupError_1 = require("./types/GetGroup/GetGroupError");
const GetGroupError_2 = require("./types/GetGroup/GetGroupError");
const GetGroupError_3 = require("./types/GetGroup/GetGroupError");
const GetGroupError_4 = require("./types/GetGroup/GetGroupError");
const GetGroupError_5 = require("./types/GetGroup/GetGroupError");
const GetGroupError_6 = require("./types/GetGroup/GetGroupError");
const GetGroupError_7 = require("./types/GetGroup/GetGroupError");
const GetGroupError_8 = require("./types/GetGroup/GetGroupError");
const GetInformationsError_1 = require("./types/GetInformations/GetInformationsError");
const GetInformationsError_2 = require("./types/GetInformations/GetInformationsError");
const GetInformationsError_3 = require("./types/GetInformations/GetInformationsError");
const GetInformationsError_4 = require("./types/GetInformations/GetInformationsError");
const GetInformationsError_5 = require("./types/GetInformations/GetInformationsError");
const GetInformationsError_6 = require("./types/GetInformations/GetInformationsError");
const GetInformationsError_7 = require("./types/GetInformations/GetInformationsError");
const GetInvoiceError_1 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_2 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_3 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_4 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_5 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_6 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_7 = require("./types/GetInvoice/GetInvoiceError");
const GetInvoiceError_8 = require("./types/GetInvoice/GetInvoiceError");
const GetPlanError_1 = require("./types/GetPlan/GetPlanError");
const GetPlanError_2 = require("./types/GetPlan/GetPlanError");
const GetPlanError_3 = require("./types/GetPlan/GetPlanError");
const GetPlanError_4 = require("./types/GetPlan/GetPlanError");
const GetPlanError_5 = require("./types/GetPlan/GetPlanError");
const GetPlanError_6 = require("./types/GetPlan/GetPlanError");
const GetPlanError_7 = require("./types/GetPlan/GetPlanError");
const GetPlanError_8 = require("./types/GetPlan/GetPlanError");
const GetPlanGroupError_1 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_2 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_3 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_4 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_5 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_6 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_7 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetPlanGroupError_8 = require("./types/GetPlanGroup/GetPlanGroupError");
const GetStripePaymentMethodError_1 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_2 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_3 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_4 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_5 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_6 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_7 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetStripePaymentMethodError_8 = require("./types/GetStripePaymentMethod/GetStripePaymentMethodError");
const GetSubscriptionError_1 = require("./types/GetSubscription/GetSubscriptionError");
const GetSubscriptionError_2 = require("./types/GetSubscription/GetSubscriptionError");
const GetSubscriptionError_3 = require("./types/GetSubscription/GetSubscriptionError");
const GetSubscriptionError_4 = require("./types/GetSubscription/GetSubscriptionError");
const GetSubscriptionError_5 = require("./types/GetSubscription/GetSubscriptionError");
const GetSubscriptionError_6 = require("./types/GetSubscription/GetSubscriptionError");
const GetSubscriptionError_7 = require("./types/GetSubscription/GetSubscriptionError");
const InitiatePaypalPaymentError_1 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_2 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_3 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_4 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_5 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_6 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_7 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_8 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_9 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiatePaypalPaymentError_10 = require("./types/InitiatePaypalPayment/InitiatePaypalPaymentError");
const InitiateStripePaymentError_1 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_2 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_3 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_4 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_5 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_6 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_7 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_8 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_9 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const InitiateStripePaymentError_10 = require("./types/InitiateStripePayment/InitiateStripePaymentError");
const ListGroupPlansError_1 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_2 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_3 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_4 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_5 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_6 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_7 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListGroupPlansError_8 = require("./types/ListGroupPlans/ListGroupPlansError");
const ListInvoicesError_1 = require("./types/ListInvoices/ListInvoicesError");
const ListInvoicesError_2 = require("./types/ListInvoices/ListInvoicesError");
const ListInvoicesError_3 = require("./types/ListInvoices/ListInvoicesError");
const ListInvoicesError_4 = require("./types/ListInvoices/ListInvoicesError");
const ListInvoicesError_5 = require("./types/ListInvoices/ListInvoicesError");
const ListInvoicesError_6 = require("./types/ListInvoices/ListInvoicesError");
const ListSubscriptionLimitsError_1 = require("./types/ListSubscriptionLimits/ListSubscriptionLimitsError");
const ListSubscriptionLimitsError_2 = require("./types/ListSubscriptionLimits/ListSubscriptionLimitsError");
const ListSubscriptionLimitsError_3 = require("./types/ListSubscriptionLimits/ListSubscriptionLimitsError");
const ListSubscriptionLimitsError_4 = require("./types/ListSubscriptionLimits/ListSubscriptionLimitsError");
const ListSubscriptionLimitsError_5 = require("./types/ListSubscriptionLimits/ListSubscriptionLimitsError");
const ListSubscriptionLimitsError_6 = require("./types/ListSubscriptionLimits/ListSubscriptionLimitsError");
exports.errors = {
    UnsubscribeSubscription: {
        InvalidParameterError: UnsubscribeSubscriptionError_2.InvalidParameterError,
        UnauthorizedError: UnsubscribeSubscriptionError_3.UnauthorizedError,
        ForbiddenError: UnsubscribeSubscriptionError_4.ForbiddenError,
        NotFoundError: UnsubscribeSubscriptionError_5.NotFoundError,
        InternalServerError: UnsubscribeSubscriptionError_6.InternalServerError,
        BadGatewayError: UnsubscribeSubscriptionError_7.BadGatewayError,
        GatewayTimeoutError: UnsubscribeSubscriptionError_8.GatewayTimeoutError,
        GenericError: UnsubscribeSubscriptionError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateInformations: {
        InvalidVatNumberError: UpdateInformationsError_2.InvalidVatNumberError,
        InvalidParameterError: UpdateInformationsError_3.InvalidParameterError,
        UnauthorizedError: UpdateInformationsError_4.UnauthorizedError,
        VatNumberNotUpdatableError: UpdateInformationsError_5.VatNumberNotUpdatableError,
        ForbiddenError: UpdateInformationsError_6.ForbiddenError,
        NotFoundError: UpdateInformationsError_7.NotFoundError,
        InternalServerError: UpdateInformationsError_8.InternalServerError,
        BadGatewayError: UpdateInformationsError_9.BadGatewayError,
        GatewayTimeoutError: UpdateInformationsError_10.GatewayTimeoutError,
        GenericError: UpdateInformationsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateStripeSetupIntent: {
        UnauthorizedError: CreateStripeSetupIntentError_2.UnauthorizedError,
        InvalidPaymentProviderError: CreateStripeSetupIntentError_3.InvalidPaymentProviderError,
        ForbiddenError: CreateStripeSetupIntentError_4.ForbiddenError,
        NotFoundError: CreateStripeSetupIntentError_5.NotFoundError,
        InternalServerError: CreateStripeSetupIntentError_6.InternalServerError,
        BadGatewayError: CreateStripeSetupIntentError_7.BadGatewayError,
        GatewayTimeoutError: CreateStripeSetupIntentError_8.GatewayTimeoutError,
        GenericError: CreateStripeSetupIntentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateSubscription: {
        InvalidParameterError: CreateSubscriptionError_2.InvalidParameterError,
        UnauthorizedError: CreateSubscriptionError_3.UnauthorizedError,
        InvalidPaymentInformationsError: CreateSubscriptionError_4.InvalidPaymentInformationsError,
        InvalidPlanError: CreateSubscriptionError_5.InvalidPlanError,
        ForbiddenError: CreateSubscriptionError_6.ForbiddenError,
        NotFoundError: CreateSubscriptionError_7.NotFoundError,
        InternalServerError: CreateSubscriptionError_8.InternalServerError,
        BadGatewayError: CreateSubscriptionError_9.BadGatewayError,
        GatewayTimeoutError: CreateSubscriptionError_10.GatewayTimeoutError,
        GenericError: CreateSubscriptionError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ExecutePaypalPayment: {
        InvalidParameterError: ExecutePaypalPaymentError_2.InvalidParameterError,
        UnauthorizedError: ExecutePaypalPaymentError_3.UnauthorizedError,
        ForbiddenError: ExecutePaypalPaymentError_4.ForbiddenError,
        ConflictError: ExecutePaypalPaymentError_5.ConflictError,
        InternalServerError: ExecutePaypalPaymentError_6.InternalServerError,
        BadGatewayError: ExecutePaypalPaymentError_7.BadGatewayError,
        GatewayTimeoutError: ExecutePaypalPaymentError_8.GatewayTimeoutError,
        GenericError: ExecutePaypalPaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ExecuteStripePayment: {
        InvalidParameterError: ExecuteStripePaymentError_2.InvalidParameterError,
        UnauthorizedError: ExecuteStripePaymentError_3.UnauthorizedError,
        InvalidPaymentProviderError: ExecuteStripePaymentError_4.InvalidPaymentProviderError,
        ForbiddenError: ExecuteStripePaymentError_5.ForbiddenError,
        NotFoundError: ExecuteStripePaymentError_6.NotFoundError,
        ConflictError: ExecuteStripePaymentError_7.ConflictError,
        InternalServerError: ExecuteStripePaymentError_8.InternalServerError,
        BadGatewayError: ExecuteStripePaymentError_9.BadGatewayError,
        GatewayTimeoutError: ExecuteStripePaymentError_10.GatewayTimeoutError,
        GenericError: ExecuteStripePaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetGroup: {
        InvalidParameterError: GetGroupError_2.InvalidParameterError,
        UnauthorizedError: GetGroupError_3.UnauthorizedError,
        ForbiddenError: GetGroupError_4.ForbiddenError,
        NotFoundError: GetGroupError_5.NotFoundError,
        InternalServerError: GetGroupError_6.InternalServerError,
        BadGatewayError: GetGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetGroupError_8.GatewayTimeoutError,
        GenericError: GetGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetInformations: {
        UnauthorizedError: GetInformationsError_2.UnauthorizedError,
        ForbiddenError: GetInformationsError_3.ForbiddenError,
        NotFoundError: GetInformationsError_4.NotFoundError,
        InternalServerError: GetInformationsError_5.InternalServerError,
        BadGatewayError: GetInformationsError_6.BadGatewayError,
        GatewayTimeoutError: GetInformationsError_7.GatewayTimeoutError,
        GenericError: GetInformationsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetInvoice: {
        InvalidParameterError: GetInvoiceError_2.InvalidParameterError,
        UnauthorizedError: GetInvoiceError_3.UnauthorizedError,
        ForbiddenError: GetInvoiceError_4.ForbiddenError,
        NotFoundError: GetInvoiceError_5.NotFoundError,
        InternalServerError: GetInvoiceError_6.InternalServerError,
        BadGatewayError: GetInvoiceError_7.BadGatewayError,
        GatewayTimeoutError: GetInvoiceError_8.GatewayTimeoutError,
        GenericError: GetInvoiceError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetPlan: {
        InvalidParameterError: GetPlanError_2.InvalidParameterError,
        UnauthorizedError: GetPlanError_3.UnauthorizedError,
        ForbiddenError: GetPlanError_4.ForbiddenError,
        NotFoundError: GetPlanError_5.NotFoundError,
        InternalServerError: GetPlanError_6.InternalServerError,
        BadGatewayError: GetPlanError_7.BadGatewayError,
        GatewayTimeoutError: GetPlanError_8.GatewayTimeoutError,
        GenericError: GetPlanError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetPlanGroup: {
        InvalidParameterError: GetPlanGroupError_2.InvalidParameterError,
        UnauthorizedError: GetPlanGroupError_3.UnauthorizedError,
        ForbiddenError: GetPlanGroupError_4.ForbiddenError,
        NotFoundError: GetPlanGroupError_5.NotFoundError,
        InternalServerError: GetPlanGroupError_6.InternalServerError,
        BadGatewayError: GetPlanGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetPlanGroupError_8.GatewayTimeoutError,
        GenericError: GetPlanGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetStripePaymentMethod: {
        UnauthorizedError: GetStripePaymentMethodError_2.UnauthorizedError,
        InvalidModeOrPaymentProviderError: GetStripePaymentMethodError_3.InvalidModeOrPaymentProviderError,
        ForbiddenError: GetStripePaymentMethodError_4.ForbiddenError,
        NotFoundError: GetStripePaymentMethodError_5.NotFoundError,
        InternalServerError: GetStripePaymentMethodError_6.InternalServerError,
        BadGatewayError: GetStripePaymentMethodError_7.BadGatewayError,
        GatewayTimeoutError: GetStripePaymentMethodError_8.GatewayTimeoutError,
        GenericError: GetStripePaymentMethodError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetSubscription: {
        UnauthorizedError: GetSubscriptionError_2.UnauthorizedError,
        ForbiddenError: GetSubscriptionError_3.ForbiddenError,
        NotFoundError: GetSubscriptionError_4.NotFoundError,
        InternalServerError: GetSubscriptionError_5.InternalServerError,
        BadGatewayError: GetSubscriptionError_6.BadGatewayError,
        GatewayTimeoutError: GetSubscriptionError_7.GatewayTimeoutError,
        GenericError: GetSubscriptionError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InitiatePaypalPayment: {
        UnauthorizedError: InitiatePaypalPaymentError_2.UnauthorizedError,
        InvalidPaymentInformationsError: InitiatePaypalPaymentError_3.InvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiatePaypalPaymentError_4.InvalidSubscriptionError,
        NoPaymentRequiredError: InitiatePaypalPaymentError_5.NoPaymentRequiredError,
        ForbiddenError: InitiatePaypalPaymentError_6.ForbiddenError,
        NotFoundError: InitiatePaypalPaymentError_7.NotFoundError,
        InternalServerError: InitiatePaypalPaymentError_8.InternalServerError,
        BadGatewayError: InitiatePaypalPaymentError_9.BadGatewayError,
        GatewayTimeoutError: InitiatePaypalPaymentError_10.GatewayTimeoutError,
        GenericError: InitiatePaypalPaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InitiateStripePayment: {
        UnauthorizedError: InitiateStripePaymentError_2.UnauthorizedError,
        InvalidPaymentInformationsError: InitiateStripePaymentError_3.InvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiateStripePaymentError_4.InvalidSubscriptionError,
        NoPaymentRequiredError: InitiateStripePaymentError_5.NoPaymentRequiredError,
        ForbiddenError: InitiateStripePaymentError_6.ForbiddenError,
        NotFoundError: InitiateStripePaymentError_7.NotFoundError,
        InternalServerError: InitiateStripePaymentError_8.InternalServerError,
        BadGatewayError: InitiateStripePaymentError_9.BadGatewayError,
        GatewayTimeoutError: InitiateStripePaymentError_10.GatewayTimeoutError,
        GenericError: InitiateStripePaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListGroupPlans: {
        InvalidParameterError: ListGroupPlansError_2.InvalidParameterError,
        UnauthorizedError: ListGroupPlansError_3.UnauthorizedError,
        ForbiddenError: ListGroupPlansError_4.ForbiddenError,
        NotFoundError: ListGroupPlansError_5.NotFoundError,
        InternalServerError: ListGroupPlansError_6.InternalServerError,
        BadGatewayError: ListGroupPlansError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupPlansError_8.GatewayTimeoutError,
        GenericError: ListGroupPlansError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListInvoices: {
        UnauthorizedError: ListInvoicesError_2.UnauthorizedError,
        ForbiddenError: ListInvoicesError_3.ForbiddenError,
        InternalServerError: ListInvoicesError_4.InternalServerError,
        BadGatewayError: ListInvoicesError_5.BadGatewayError,
        GatewayTimeoutError: ListInvoicesError_6.GatewayTimeoutError,
        GenericError: ListInvoicesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListSubscriptionLimits: {
        UnauthorizedError: ListSubscriptionLimitsError_2.UnauthorizedError,
        ForbiddenError: ListSubscriptionLimitsError_3.ForbiddenError,
        InternalServerError: ListSubscriptionLimitsError_4.InternalServerError,
        BadGatewayError: ListSubscriptionLimitsError_5.BadGatewayError,
        GatewayTimeoutError: ListSubscriptionLimitsError_6.GatewayTimeoutError,
        GenericError: ListSubscriptionLimitsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UnsubscribeSubscriptionError: {
        InvalidParameterError: UnsubscribeSubscriptionError_2.InvalidParameterError,
        UnauthorizedError: UnsubscribeSubscriptionError_3.UnauthorizedError,
        ForbiddenError: UnsubscribeSubscriptionError_4.ForbiddenError,
        NotFoundError: UnsubscribeSubscriptionError_5.NotFoundError,
        InternalServerError: UnsubscribeSubscriptionError_6.InternalServerError,
        BadGatewayError: UnsubscribeSubscriptionError_7.BadGatewayError,
        GatewayTimeoutError: UnsubscribeSubscriptionError_8.GatewayTimeoutError,
        GenericError: UnsubscribeSubscriptionError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    UpdateInformationsError: {
        InvalidVatNumberError: UpdateInformationsError_2.InvalidVatNumberError,
        InvalidParameterError: UpdateInformationsError_3.InvalidParameterError,
        UnauthorizedError: UpdateInformationsError_4.UnauthorizedError,
        VatNumberNotUpdatableError: UpdateInformationsError_5.VatNumberNotUpdatableError,
        ForbiddenError: UpdateInformationsError_6.ForbiddenError,
        NotFoundError: UpdateInformationsError_7.NotFoundError,
        InternalServerError: UpdateInformationsError_8.InternalServerError,
        BadGatewayError: UpdateInformationsError_9.BadGatewayError,
        GatewayTimeoutError: UpdateInformationsError_10.GatewayTimeoutError,
        GenericError: UpdateInformationsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateStripeSetupIntentError: {
        UnauthorizedError: CreateStripeSetupIntentError_2.UnauthorizedError,
        InvalidPaymentProviderError: CreateStripeSetupIntentError_3.InvalidPaymentProviderError,
        ForbiddenError: CreateStripeSetupIntentError_4.ForbiddenError,
        NotFoundError: CreateStripeSetupIntentError_5.NotFoundError,
        InternalServerError: CreateStripeSetupIntentError_6.InternalServerError,
        BadGatewayError: CreateStripeSetupIntentError_7.BadGatewayError,
        GatewayTimeoutError: CreateStripeSetupIntentError_8.GatewayTimeoutError,
        GenericError: CreateStripeSetupIntentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateSubscriptionError: {
        InvalidParameterError: CreateSubscriptionError_2.InvalidParameterError,
        UnauthorizedError: CreateSubscriptionError_3.UnauthorizedError,
        InvalidPaymentInformationsError: CreateSubscriptionError_4.InvalidPaymentInformationsError,
        InvalidPlanError: CreateSubscriptionError_5.InvalidPlanError,
        ForbiddenError: CreateSubscriptionError_6.ForbiddenError,
        NotFoundError: CreateSubscriptionError_7.NotFoundError,
        InternalServerError: CreateSubscriptionError_8.InternalServerError,
        BadGatewayError: CreateSubscriptionError_9.BadGatewayError,
        GatewayTimeoutError: CreateSubscriptionError_10.GatewayTimeoutError,
        GenericError: CreateSubscriptionError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ExecutePaypalPaymentError: {
        InvalidParameterError: ExecutePaypalPaymentError_2.InvalidParameterError,
        UnauthorizedError: ExecutePaypalPaymentError_3.UnauthorizedError,
        ForbiddenError: ExecutePaypalPaymentError_4.ForbiddenError,
        ConflictError: ExecutePaypalPaymentError_5.ConflictError,
        InternalServerError: ExecutePaypalPaymentError_6.InternalServerError,
        BadGatewayError: ExecutePaypalPaymentError_7.BadGatewayError,
        GatewayTimeoutError: ExecutePaypalPaymentError_8.GatewayTimeoutError,
        GenericError: ExecutePaypalPaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ExecuteStripePaymentError: {
        InvalidParameterError: ExecuteStripePaymentError_2.InvalidParameterError,
        UnauthorizedError: ExecuteStripePaymentError_3.UnauthorizedError,
        InvalidPaymentProviderError: ExecuteStripePaymentError_4.InvalidPaymentProviderError,
        ForbiddenError: ExecuteStripePaymentError_5.ForbiddenError,
        NotFoundError: ExecuteStripePaymentError_6.NotFoundError,
        ConflictError: ExecuteStripePaymentError_7.ConflictError,
        InternalServerError: ExecuteStripePaymentError_8.InternalServerError,
        BadGatewayError: ExecuteStripePaymentError_9.BadGatewayError,
        GatewayTimeoutError: ExecuteStripePaymentError_10.GatewayTimeoutError,
        GenericError: ExecuteStripePaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetGroupError: {
        InvalidParameterError: GetGroupError_2.InvalidParameterError,
        UnauthorizedError: GetGroupError_3.UnauthorizedError,
        ForbiddenError: GetGroupError_4.ForbiddenError,
        NotFoundError: GetGroupError_5.NotFoundError,
        InternalServerError: GetGroupError_6.InternalServerError,
        BadGatewayError: GetGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetGroupError_8.GatewayTimeoutError,
        GenericError: GetGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetInformationsError: {
        UnauthorizedError: GetInformationsError_2.UnauthorizedError,
        ForbiddenError: GetInformationsError_3.ForbiddenError,
        NotFoundError: GetInformationsError_4.NotFoundError,
        InternalServerError: GetInformationsError_5.InternalServerError,
        BadGatewayError: GetInformationsError_6.BadGatewayError,
        GatewayTimeoutError: GetInformationsError_7.GatewayTimeoutError,
        GenericError: GetInformationsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetInvoiceError: {
        InvalidParameterError: GetInvoiceError_2.InvalidParameterError,
        UnauthorizedError: GetInvoiceError_3.UnauthorizedError,
        ForbiddenError: GetInvoiceError_4.ForbiddenError,
        NotFoundError: GetInvoiceError_5.NotFoundError,
        InternalServerError: GetInvoiceError_6.InternalServerError,
        BadGatewayError: GetInvoiceError_7.BadGatewayError,
        GatewayTimeoutError: GetInvoiceError_8.GatewayTimeoutError,
        GenericError: GetInvoiceError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetPlanError: {
        InvalidParameterError: GetPlanError_2.InvalidParameterError,
        UnauthorizedError: GetPlanError_3.UnauthorizedError,
        ForbiddenError: GetPlanError_4.ForbiddenError,
        NotFoundError: GetPlanError_5.NotFoundError,
        InternalServerError: GetPlanError_6.InternalServerError,
        BadGatewayError: GetPlanError_7.BadGatewayError,
        GatewayTimeoutError: GetPlanError_8.GatewayTimeoutError,
        GenericError: GetPlanError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetPlanGroupError: {
        InvalidParameterError: GetPlanGroupError_2.InvalidParameterError,
        UnauthorizedError: GetPlanGroupError_3.UnauthorizedError,
        ForbiddenError: GetPlanGroupError_4.ForbiddenError,
        NotFoundError: GetPlanGroupError_5.NotFoundError,
        InternalServerError: GetPlanGroupError_6.InternalServerError,
        BadGatewayError: GetPlanGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetPlanGroupError_8.GatewayTimeoutError,
        GenericError: GetPlanGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetStripePaymentMethodError: {
        UnauthorizedError: GetStripePaymentMethodError_2.UnauthorizedError,
        InvalidModeOrPaymentProviderError: GetStripePaymentMethodError_3.InvalidModeOrPaymentProviderError,
        ForbiddenError: GetStripePaymentMethodError_4.ForbiddenError,
        NotFoundError: GetStripePaymentMethodError_5.NotFoundError,
        InternalServerError: GetStripePaymentMethodError_6.InternalServerError,
        BadGatewayError: GetStripePaymentMethodError_7.BadGatewayError,
        GatewayTimeoutError: GetStripePaymentMethodError_8.GatewayTimeoutError,
        GenericError: GetStripePaymentMethodError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetSubscriptionError: {
        UnauthorizedError: GetSubscriptionError_2.UnauthorizedError,
        ForbiddenError: GetSubscriptionError_3.ForbiddenError,
        NotFoundError: GetSubscriptionError_4.NotFoundError,
        InternalServerError: GetSubscriptionError_5.InternalServerError,
        BadGatewayError: GetSubscriptionError_6.BadGatewayError,
        GatewayTimeoutError: GetSubscriptionError_7.GatewayTimeoutError,
        GenericError: GetSubscriptionError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InitiatePaypalPaymentError: {
        UnauthorizedError: InitiatePaypalPaymentError_2.UnauthorizedError,
        InvalidPaymentInformationsError: InitiatePaypalPaymentError_3.InvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiatePaypalPaymentError_4.InvalidSubscriptionError,
        NoPaymentRequiredError: InitiatePaypalPaymentError_5.NoPaymentRequiredError,
        ForbiddenError: InitiatePaypalPaymentError_6.ForbiddenError,
        NotFoundError: InitiatePaypalPaymentError_7.NotFoundError,
        InternalServerError: InitiatePaypalPaymentError_8.InternalServerError,
        BadGatewayError: InitiatePaypalPaymentError_9.BadGatewayError,
        GatewayTimeoutError: InitiatePaypalPaymentError_10.GatewayTimeoutError,
        GenericError: InitiatePaypalPaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InitiateStripePaymentError: {
        UnauthorizedError: InitiateStripePaymentError_2.UnauthorizedError,
        InvalidPaymentInformationsError: InitiateStripePaymentError_3.InvalidPaymentInformationsError,
        InvalidSubscriptionError: InitiateStripePaymentError_4.InvalidSubscriptionError,
        NoPaymentRequiredError: InitiateStripePaymentError_5.NoPaymentRequiredError,
        ForbiddenError: InitiateStripePaymentError_6.ForbiddenError,
        NotFoundError: InitiateStripePaymentError_7.NotFoundError,
        InternalServerError: InitiateStripePaymentError_8.InternalServerError,
        BadGatewayError: InitiateStripePaymentError_9.BadGatewayError,
        GatewayTimeoutError: InitiateStripePaymentError_10.GatewayTimeoutError,
        GenericError: InitiateStripePaymentError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListGroupPlansError: {
        InvalidParameterError: ListGroupPlansError_2.InvalidParameterError,
        UnauthorizedError: ListGroupPlansError_3.UnauthorizedError,
        ForbiddenError: ListGroupPlansError_4.ForbiddenError,
        NotFoundError: ListGroupPlansError_5.NotFoundError,
        InternalServerError: ListGroupPlansError_6.InternalServerError,
        BadGatewayError: ListGroupPlansError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupPlansError_8.GatewayTimeoutError,
        GenericError: ListGroupPlansError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListInvoicesError: {
        UnauthorizedError: ListInvoicesError_2.UnauthorizedError,
        ForbiddenError: ListInvoicesError_3.ForbiddenError,
        InternalServerError: ListInvoicesError_4.InternalServerError,
        BadGatewayError: ListInvoicesError_5.BadGatewayError,
        GatewayTimeoutError: ListInvoicesError_6.GatewayTimeoutError,
        GenericError: ListInvoicesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ListSubscriptionLimitsError: {
        UnauthorizedError: ListSubscriptionLimitsError_2.UnauthorizedError,
        ForbiddenError: ListSubscriptionLimitsError_3.ForbiddenError,
        InternalServerError: ListSubscriptionLimitsError_4.InternalServerError,
        BadGatewayError: ListSubscriptionLimitsError_5.BadGatewayError,
        GatewayTimeoutError: ListSubscriptionLimitsError_6.GatewayTimeoutError,
        GenericError: ListSubscriptionLimitsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
